module.exports = __webpack_public_path__ + "5752d7b144e040366d0ed217c647b495.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_folder.png
// module id = 79
// module chunks = 0 1 2 3 4